import { CloseIcon } from '@chakra-ui/icons';
import { Box, IconButton } from '@chakra-ui/react';

import { Text } from '@revelio/ui';

import type { DataBuilderCustomColumn } from '../../data-builder.store';
import { DataBuilderOption } from '../ui/DataBuilderOption';

type AddCustomColumnOptionProps = {
  onClick: () => void;
};

export function AddCustomColumnOption({ onClick }: AddCustomColumnOptionProps) {
  return (
    <DataBuilderOption
      data-testid="data-builder-add-custom-column"
      isSelected={false}
      onClick={onClick}
      startSlot={<DataBuilderOption.CheckBox isSelected={false} />}
    >
      <Text fontSize="md" style={{ color: 'var(--chakra-colors-blue-300)' }}>
        + Add Custom
      </Text>
    </DataBuilderOption>
  );
}

type CustomColumnCardProps = {
  column: DataBuilderCustomColumn;
  onClick: () => void;
  onRemove: () => void;
};

export function CustomColumnCard({
  column,
  onClick,
  onRemove,
}: CustomColumnCardProps) {
  return (
    <Box position="relative">
      <DataBuilderOption
        data-testid={`data-builder-custom-column-${column.name}`}
        isSelected
        onClick={onClick}
        startSlot={<DataBuilderOption.CheckBox isSelected />}
      >
        <Text fontSize="md">{column.name}</Text>
      </DataBuilderOption>
      <IconButton
        aria-label={`Remove column ${column.name}`}
        icon={<CloseIcon boxSize={2} />}
        size="xs"
        variant="ghost"
        colorScheme="red"
        position="absolute"
        top={1}
        right={1}
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
        data-testid={`data-builder-remove-custom-column-${column.name}`}
      />
    </Box>
  );
}
